import React, { Component } from "react";
import { connect } from 'react-redux'
import { NavLink } from "react-router-dom"

import Btn from "../../../Components/Btn";
import { fullDate } from '../../../helpers/formatters';
import { bindActionCreators } from 'redux';
import { deleteAdmin } from '../../../store/user/actions';
import Alert from '../../../Components/Alert';
import Popup from '../../../Components/Popup';
import { loaderstyle } from '../../../config';
import LoadingOverlay from 'react-loading-overlay';

class AdminsTable extends Component {
  state = {
    popupOpen: false,
    selectedAdmin: {},
    error: ''
  }

  openPopup = (admin) => {
    this.setState({selectedAdmin: admin, popupOpen: true});
  }

  closePopup = () => {
    this.setState({selectedAdmin: {}, popupOpen: false});
  }

  deleteAdmin = (admin) => {
    this.props.deleteAdmin(admin._id, () => {
      this.closePopup();
      this.props.onAdminDeleted(admin.email);
    })
  }

  render() {
    const { selectedAdmin, popupOpen } = this.state;
    const { admins, email, error } = this.props;

    return (
      <div className="booking-table-card">
        {/* <Pagination
          currentPage={this.props.current_page}
          totalPages={this.props.total_pages}
          selectPage={this.props.setPage} />
        <Display
          label="Display"
          onChange={this.setPerPage}
          options={[100, 200, 300]} /> */}
        <Alert msg={error} color="red" />
        <Popup open={popupOpen} onClose={this.closePopup} renderActionButtons={() => (
          <>
            <Btn className="btn danger" onClick={this.deleteAdmin.bind(this, selectedAdmin)}>Yes!</Btn>
            <Btn className="btn simple" onClick={this.closePopup}>cancel</Btn>
          </>
        )}>
          <p>Are you sure you want to delete {selectedAdmin.email}?</p>
        </Popup>
        <LoadingOverlay
          active={this.props.loading}
          text="Loading..."
          spinner
          styles={loaderstyle}
        >
          <div className="table-responsive">
            <table className="basic-table">
              <thead>
                <tr>
                  <th>Name</th>
                  <th>Email</th>
                  <th>Last Login</th>
                  <th></th>
                </tr>
              </thead>
              <tbody>{admins.map(admin => (
                <tr key={admin._id}>
                  <td><div className="nowrap">{admin.name}</div></td>
                  <td><div className="nowrap">{admin.email}</div></td>
                  <td><div className="nowrap">{admin.last_login ? fullDate(admin.last_login) : "Never"}</div></td>
                  <td className="text-right">
                    <div className="actions">
                      {/* <Btn className="btn unstyled"><img src="/imgs/icons/sort.png" alt="sort icon" width="17" /></Btn> */}
                      {admin.email !== email &&
                        <Btn className="btn danger" onClick={this.openPopup.bind(this, admin)}>delete</Btn>}
                      <NavLink className="btn simple" to={`/edit-admin/${admin._id}`}>edit</NavLink>
                      {/* <Btn className="btn simple">edit</Btn> */}
                    </div>
                  </td>
                </tr>
              ))}</tbody>
            </table>
          </div>
        </LoadingOverlay>
        {/* <Pagination
          currentPage={this.props.current_page}
          totalPages={this.props.total_pages}
          selectPage={this.props.setPage} /> */}
      </div>
    );
  }
}

const mapStateToProps = (state) => ({
  email: state.user.email,
  admins: state.user.admins,
  error: state.user.error,
  loading: state.user.loading
})

const mapDispatchToProps = (dispatch) => ({
  deleteAdmin: bindActionCreators(deleteAdmin, dispatch)
})


export default connect(mapStateToProps, mapDispatchToProps)(AdminsTable);